export const SET_PAGE_POSITION = 'tracking//SET_PAGE_POSITION';
export const INIT_TRACKING = 'tracking//INIT_TRACKING';
export const SET_PAGE_META = 'tracking//SET_PAGE_META';
export const SET_SESSION_TOKEN = 'tracking//SET_SESSION_TOKEN';
export const SET_REF_CODE = 'tracking//SET_REF_CODE';
export const CATEGORY_CUSTOM_ALERTS = "customAlerts";